// Per-garment tweaks (scale + offset) dla ubrań Natalki.
// Źródłem prawdy jest stan gracza na serwerze (state.cloth_tweaks), więc konfiguracja
// jest taka sama na każdym urządzeniu po zalogowaniu. Edycja przez ClothTweakHud (klawisz T).
//
// Klucze tekstur w grze mają prefiks "cloth_" (np. "cloth_bluzka_red"); backend trzyma je
// po id ubrania bez prefiksu ("bluzka_red"). stripPrefix() mostkuje te dwie konwencje.

import { gameState } from '../state/gameState.js';
import { DEFAULT_TWEAK, defaultTweak } from './clothDefaults.js';

const LEGACY_KEY = 'clothTweaks_v1';
const DEBOUNCE_MS = 450;
export { DEFAULT_TWEAK };

const stripPrefix = (clothKey) => clothKey.replace(/^cloth_/, '');
const myCharacter = () => (typeof window !== 'undefined' ? window.__myCharacter : null) ?? 'natalka';
// Base = per-garment default for MY character; the player's saved tweak (absolute values)
// replaces it, and the optimistic overlay sits on top.
const base = (item) => defaultTweak(item, myCharacter());

// Optymistyczna nakładka: wartości zmienione lokalnie, jeszcze niepotwierdzone przez serwer.
// Dzięki niej suwaki reagują natychmiast, mimo że zapis jest debounce'owany. Klucz: id bez prefiksu.
const pending = {};
const timers = {};

function serverTweak(item) {
  return gameState.raw?.cloth_tweaks?.[item];
}

function flush(item) {
  const tw = pending[item];
  if (!tw) return;
  gameState.setClothTweak(item, tw)
    .then(() => { delete pending[item]; })   // serwer ma już wartość → nakładka zbędna
    .catch(() => { /* zostaw w pending; ponowi się przy następnej zmianie */ });
}

export const clothTweaks = {
  get(clothKey) {
    const item = stripPrefix(clothKey);
    return { ...base(item), ...(serverTweak(item) || {}), ...(pending[item] || {}) };
  },
  set(clothKey, partial) {
    const item = stripPrefix(clothKey);
    pending[item] = { ...base(item), ...(serverTweak(item) || {}), ...(pending[item] || {}), ...partial };
    clearTimeout(timers[item]);
    timers[item] = setTimeout(() => flush(item), DEBOUNCE_MS);
  },
  reset(clothKey) {
    const item = stripPrefix(clothKey);
    delete pending[item];
    clearTimeout(timers[item]);
    gameState.resetClothTweak(item).catch(() => {});
  },
};

// Jednorazowa migracja: jeśli na tym urządzeniu są stare tweaki w localStorage, a serwer
// jeszcze ich nie ma — wyślij je w górę, żeby przeniosły się na konto. Wywoływane raz po
// pierwszym załadowaniu stanu (BootScene). Bezpieczne do wielokrotnego wywołania.
export async function migrateLocalTweaksToServer() {
  const server = gameState.raw?.cloth_tweaks || {};
  if (Object.keys(server).length > 0) return;   // konto ma już konfigurację — nie nadpisuj
  let local;
  try { local = JSON.parse(localStorage.getItem(LEGACY_KEY)) || {}; } catch { local = {}; }
  const entries = Object.entries(local);
  if (!entries.length) return;
  for (const [clothKey, tw] of entries) {
    const item = stripPrefix(clothKey);
    try { await gameState.setClothTweak(item, { ...DEFAULT_TWEAK, ...tw }); } catch { /* nieznane id → pomiń */ }
  }
}
